import React from 'react';
import { FOUNDER_BONUSES, FOUNDERS_INTRO } from '../constants/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function FoundersProgram() {
  return <section className="w-full bg-bordo-deep py-12 text-cream b760:py-16" data-id="element-86" data-mp="36smh9p5p7ryc">
      <div className="mx-auto max-w-3xl px-4 b720:px-6" data-id="element-87" data-mp="31u1h1pqg589w">
        <Reveal className="text-center" data-id="element-88" data-mp="31t9n0jchzilq">
          <span className="inline-block rounded-full border border-mustard/60 bg-mustard/10 px-4 py-1.5 text-xs font-700 uppercase tracking-wide text-mustard b640:text-sm" data-id="element-89" data-mp="2wuy9nymzupyr">
            {FOUNDERS_INTRO.badge}
          </span>
          <h2 className="mt-4 font-display text-2xl font-700 uppercase leading-tight text-cream b640:text-4xl" data-id="element-90" data-mp="2o24pbmsox0e1">
            {FOUNDERS_INTRO.title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-cream/80 b640:text-base" data-id="element-91" data-mp="2j1qi26ywxuh2">
            {FOUNDERS_INTRO.sub}
          </p>
        </Reveal>

        <div className="mt-9 space-y-6" data-id="element-92" data-mp="296osja0q6qdy">
          {FOUNDER_BONUSES.map((bonus, index) => <Reveal key={bonus.title} delay={index * 60} data-id="element-93" data-mp="2y6t1fft8ptfa" data-mpi={index}>
              <article className="rounded-2xl border-2 border-mustard bg-bordo p-5 b640:p-7" data-id="element-94" data-mp="32y1c0f6b3ku1">
                <span className="inline-block rounded-full bg-mustard px-3 py-1 text-[11px] font-700 uppercase tracking-wide text-bordo b640:text-xs" data-id="element-95" data-mp="2o9euc6t7igzn">
                  {bonus.tag}
                </span>
                <h3 className="mt-3 font-display text-xl font-700 uppercase leading-tight text-mustard b640:text-2xl" data-id="element-96" data-mp="3gyc4fmn9l7hb">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-cream/85 b640:text-base" data-id="element-97" data-mp="3lv2ritxhl3c8">
                  {bonus.desc}
                </p>

                <ul className="mt-5 space-y-2.5" data-id="element-98" data-mp="3by6j0o7l8h7o">
                  {bonus.points.map(point => <li key={point} className="flex gap-2.5 text-sm leading-relaxed text-cream/90 b640:text-base" data-id="element-99" data-mp="1vkgc79p33euc">
                      <span className="shrink-0 font-700 text-mustard" aria-hidden="true" data-id="element-100" data-mp="70u0p3tbypgr">
                        ✓
                      </span>
                      <span data-id="element-101" data-mp="3tfwnnqm2fgol">{point}</span>
                    </li>)}
                </ul>

                {bonus.footnote && <p className="mt-5 rounded-lg border-l-4 border-cream/30 bg-bordo-deep px-4 py-3 text-sm leading-relaxed text-cream/75" data-id="element-102" data-mp="3ofhb319lyd7o">
                    {bonus.footnote}
                  </p>}

                <p className="mt-5 inline-flex flex-wrap items-center gap-1.5 rounded-lg bg-mustard px-3 py-2 text-xs font-700 uppercase text-bordo b640:text-sm" data-id="element-103" data-mp="3fj9odh6n4efi">
                  <span aria-hidden="true" data-id="element-104" data-mp="35kaddryek6pc">✓</span>
                  <span data-id="element-105" data-mp="18q77995prmts">Valor:</span>
                  <span className="font-display text-sm b640:text-base" data-id="element-106" data-mp="18p4jvb7lo2im">
                    INCALCULABLE
                  </span>
                  <span data-id="element-107" data-mp="13p9qn10cr0ue">— gratis para vos</span>
                </p>
              </article>
            </Reveal>)}
        </div>

        <Reveal className="mx-auto mt-9 max-w-md" data-id="element-108" data-mp="1g9gi76tvbtky">
          <CtaButton data-id="element-109" data-mp="1g85grdnwaxx0">{FOUNDERS_INTRO.cta}</CtaButton>
          <p className="mt-2 text-center text-xs text-cream/70 b640:text-sm" data-id="element-110" data-mp="1l05cetwxn4ns">
            {FOUNDERS_INTRO.ctaSub}
          </p>
        </Reveal>
      </div>
    </section>;
}